module.exports = __webpack_public_path__ + "static/media/stargate-moab.34bb7453.jpg";